<form class="filter" #formElement [formGroup]="form">

    <mat-form-field class="medium-width">
        <input matInput autocomplete="off" formControlName="DateFrom" [matDatepicker]="pickerFrom" placeholder="Fecha desde" />
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input matInput autocomplete="off" formControlName="DateTo" [matDatepicker]="pickerTo" placeholder="Fecha hasta" />
        <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
        <mat-datepicker #pickerTo></mat-datepicker>
    </mat-form-field>



    <mat-form-field class="medium-width">
        <input type="text" #entity matInput placeholder="Entidad" formControlName="Entity" [matAutocomplete]="autEntity" />
        <mat-autocomplete #autEntity="matAutocomplete" [displayWith]="filterCompleteEntities.displayFn">
            <mat-option *ngFor="let entityOption of filteredEntitiesOptions | async" [value]="entityOption">
                {{ entityOption.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input type="text" #service matInput placeholder="Servicio" formControlName="Service" [matAutocomplete]="autService" />
        <mat-autocomplete #autService="matAutocomplete" [displayWith]="filterCompleteServices.displayFn">
            <mat-option *ngFor="let serviceOption of filteredServicesOptions | async" [value]="serviceOption">
                {{ serviceOption.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <input type="text" #specialty matInput placeholder="Especialidad" formControlName="Specialty" [matAutocomplete]="autSpecialty" />
        <mat-autocomplete #autSpecialty="matAutocomplete" [displayWith]="filterCompleteSpecialties.displayFn">
            <mat-option *ngFor="let specialtyOption of filteredSpecialtiesOptions | async" [value]="specialtyOption">
                {{ specialtyOption.Name }}
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="medium-width">
        <mat-select placeholder="Categoría" formControlName="Category">
            <mat-option [value]="null">Todas</mat-option>
            <mat-option *ngFor="let category of medicalReportCategories" [value]="category">
                {{ category.Name }} - {{ category.Description }}
            </mat-option>
        </mat-select>
    </mat-form-field>


    <mat-form-field class="medium-width">
        <mat-select placeholder="Estados de facturación" formControlName="BillingStates" multiple>
            <mat-select-trigger>
                {{ f.BillingStates.value?.length > 0 ? f.BillingStates.value[0].Name : "" }}
                <span *ngIf="f.BillingStates.value?.length > 1" class="additional-selection">
                    (+{{ f.BillingStates.value.length - 1 }}
                    {{ f.BillingStates.value?.length === 2 ? "otro" : "otros" }})
                </span>
            </mat-select-trigger>
            <mat-option *ngFor="let billingState of billingStates" [value]="billingState">
                {{ billingState.Name }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-checkbox class="margin-right-small" formControlName="SeeOnlyNoClassified">Ver solo no clasificados</mat-checkbox>
    <mat-checkbox class="margin-right-small" formControlName="SeePublished">Ver publicados</mat-checkbox>
    <mat-checkbox class="margin-right-small" formControlName="SeeNoPublished">Ver no publicados</mat-checkbox>
    <mat-checkbox class="margin-right-small" formControlName="SeeOnlyRegistered">Ver solo registrados</mat-checkbox>
</form>